import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementData, ProposalData } from "../../models/agreement.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface RetrieveProposalUseCaseParams {
  agreementId: number;
  level: number;
}

export class RetrieveProposalUseCase
  implements UseCase<RetrieveProposalUseCaseParams, ProposalData>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: RetrieveProposalUseCaseParams): Observable<AgreementData> {
    return this.repo.loadAgreement(param.agreementId, param.level);
  }
}

const retrieveProposalUseCaseFactory = (repo: AgreementRepository) =>
  new RetrieveProposalUseCase(repo);

export const retrieveProposalUseCaseProvider: Provider = {
  provide: RetrieveProposalUseCase,
  useFactory: retrieveProposalUseCaseFactory,
  deps: [AgreementRepository],
};
